import { graphql } from 'gql.tada'
import Head from 'next/head'
import { ReactElement } from 'react'

import { ClientOnly } from '@/components/ClientOnly'
import { FullScreenLoading } from '@/components/FullScreenLoading'
import { SignUpLayout } from '@/components/layout/web'
import { Loading } from '@/components/Loading'
import { WebEula } from '@/components/web-eula'
import { useQuery } from '@/hooks/useQuery'

export default function PrivacyPolicyPage() {
  const [{ data: latestContractsData, fetching }] = useQuery({
    query: PrivacyPolicyPage_Query,
    requestPolicy: 'cache-and-network',
  })
  const contract = latestContractsData?.latestContract
  return (
    <>
      <Head>
        <title>ロジックラボ | プライバシーポリシー</title>
      </Head>

      {contract && <WebEula contract={contract} />}

      {fetching && (
        <div className="pointer-events-none fixed inset-0 grid place-items-center">
          <Loading />
        </div>
      )}
    </>
  )
}

PrivacyPolicyPage.getLayout = (page: ReactElement) => (
  <ClientOnly fallback={<FullScreenLoading />}>
    <SignUpLayout>{page}</SignUpLayout>
  </ClientOnly>
)

const PrivacyPolicyPage_Query = graphql(`
  query PrivacyPolicyPage_Query {
    latestContract(contractType: PRIVACY_POLICY) {
      id
      title
      content
    }
  }
`)
